import { render } from "./B24chat.vue?vue&type=template&id=b823e454"
import script from "./B24chat.vue?vue&type=script&lang=js"
export * from "./B24chat.vue?vue&type=script&lang=js"

import "./B24chat.vue?vue&type=style&index=0&id=b823e454&lang=css"

import exportComponent from "/builds/off-group-apps/personal-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__